import { render, staticRenderFns } from "./CartUpsellItemList.vue?vue&type=template&id=1e9db675"
import script from "./CartUpsellItemList.vue?vue&type=script&lang=ts"
export * from "./CartUpsellItemList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports